import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'app/services/authentication.service';

@Component({
  selector: 'app-salesofstock-redirect',
  templateUrl: './salesofstock-redirect.component.html',
  styleUrls: ['./salesofstock-redirect.component.css']
})
export class SalesofstockRedirectComponent implements OnInit {
  currentDate: Date;
  currentMonth: Number;
  currentYear: Number;
  constructor(
  private router: Router
  ) 
  {
    this.currentDate = new Date();
    this.currentMonth = 1 + this.currentDate.getMonth();
    this.currentYear = this.currentDate.getFullYear();
  }
  ngOnInit() {
    this.router.navigate(['salesofstock/' + this.currentMonth + '/' + this.currentYear]);
  }

}